import React, { useState, useRef } from "react";
import "./FAQSection.css";

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const contentRefs = useRef([]);

  const faqData = [
    {
      question: "Q1. Can I plan a trip without booking on ZikRme?",
      answer:
        "Yes, with ZikRme's planning access,you can fully plan your trip before booking",
    },
    {
      question: "Q2. Do you provide weekend-only tours?",
      answer:
        "Yes, we specialize with short weekend getaways.",
    },
    {
      question: "Q3. Can I customize any package?",
      answer:
        "Absolutely every package can be modified",
    },
    {
      question: "Q4. Are prices fixed or flexible?",
      answer:
        "Prices depend on dates,hotel and group size.",
    },
    {
      question: "Q5. Do you charge for itinerary planning?",
      answer:
        "Basic planning is free. custome plans may vary",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-main">
      <h1 className="faq-heading">FAQ</h1>

      <div className="faq-list">
        {faqData.map((faq, index) => (
          <div key={index} className="faq-item">
            <div className="faq-card" onClick={() => toggleFAQ(index)}>
              {faq.question}
            </div>

            <div
              className="faq-answer"
              style={{
                height:
                  openIndex === index
                    ? contentRefs.current[index]?.scrollHeight + "px"
                    : "0px",
              }}
            >
              <div
                className="faq-answer-content"
                ref={(el) => (contentRefs.current[index] = el)}
              >
                {faq.answer}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
